import { useEffect, useState } from 'react';

import { Img } from '../img/img';
const test = false;

let _mounted = false;

export const VideoUrl = (props) => {
  const { id, id1, createtime, func, className, refresh } = props;
  // const [error, setError] = useState(true);
  const [n, setN] = useState(0);

  /**
   * get element by id
   * @returns
   */
  const getEl = () => {
    return document.getElementById(id1);
  };

  /**
   * get image src
   * @returns
   */
  const getImageSrc = () => {
    return test ? '/images/test/' + id + '.jpg?ct=' + createtime : props.src;
  };

  const src = getImageSrc();

  useEffect(() => {
    _mounted = true;
    // setError(false);
    const el = getEl(id);
    if (el) {
      el.src = src;
    }

    return () => {
      _mounted = false;
      const el = getEl(id);
      if (el && el.src) {
        // setError(false);
        el.src = '';
      }
    };
  }, [src]);

  /**
   * set active cam
   */
  const setActiveCam = () => {
    func(id);
  };

  /**
   * on error
   */
  // const onError = () => {
  //   setError(true);
  //   setTimeout(() => {
  //     if (refresh) {
  //       refresh();
  //     }
  //   }, 1000);
  // };

  // /**
  //  * on load
  //  */
  // const onLoad = () => {
  //   setError(false);
  // };

  const cl = (className ?? '') + ' simple';

  const reload = () => {
    if (_mounted) {
      setN((n) => n + 1);
    }
  };

  return <Img key={n} draggable="false" onDragStart={() => false} id={id1} className={cl} src={src} onClick={setActiveCam} afterError={reload} />;
  // return error ? (
  //   <img draggable="false" onDragStart={() => false} className="error-img" src={'/images/loader2.svg'} alt="error" />
  // ) : (
  //   <img
  //     draggable="false"
  //     onLoad={onLoad}
  //     onError={onError}
  //     onDragStart={() => false}
  //     id={id1}
  //     className={className}
  //     src={src}
  //     onClick={setActiveCam}
  //     alt=""
  //   />
  // );
};
